import { createContext } from 'react';

export interface CollapsedController {
  persistent: boolean;
  collapsed: boolean;
  sideMenuKey: number;
  toggleSideMenu: () => void;
}

const CollapsedControllerContext = createContext<CollapsedController | null>(null);

export default CollapsedControllerContext;
